export default __webpack_public_path__ + "static/media/next.fe3f3ecb.svg";